import {useEffect, useState} from 'react';
import { LoiFields, LoiInt, LoiRows } from '../../../../services/models/objs/LineOfInquirySection'
import SegnalazioniStructureService from '../../../../services/controllers/segnalazioni-services/SegnalazioniStructureService';
import Tooltip from '@mui/material/Tooltip';
import { TextField } from '@mui/material';
import CustomButtonSecondary from '../../../../shared/atomic_components/button/CustomButtonSecondary';


const AddLoiSection = (props : any) => {

    const [fieldsLoi, setNewLoiFields] = useState<LoiRows[]>(readLoiStructure())
    const [loiForm, setLoiForm] = useState<{[key : string] : string}>(checkUpdate());

    
    function readLoiStructure() {
        const section = props.section;
        return section.rows
    }

    function checkUpdate() {
        const updateForm = props.loiUpdate;
        if(updateForm && updateForm['internalLoiId']){
            return updateForm
        }
        else
            return {}
    }


    function renderForm(field : LoiFields) {
        switch (field.type) {
            case "text":
                return renderTextForm(field)
            case "textArea":
                return renderTextAreaForm(field)
        }
    }

    const renderTextForm = (field : LoiFields) => {
        return <Tooltip placement="bottom" title={field.tooltipText} arrow>
            <TextField
                error={checkErrorInField(field)}
                helperText={checkErrorInField(field) ? 'Il campo è obbligatorio' : ""}
                onChange={(event => {HandleChange(event, field)})}
                fullWidth={true}
                disabled= {(field.name === 'internalLoiId' || field.name==='notaMabFileNet')? true : false}
                required={field.required}
                value={getValue(field)}
                id={field.name}
                label={field.label}
            />
        </Tooltip>
    }

    const renderTextAreaForm = (field : LoiFields) => {
        return <TextField
                rows={3}
                multiline
                error={checkErrorInField(field)}
                helperText={checkErrorInField(field) ? 'Il campo è obbligatorio' : ""}
                onChange={(event => {HandleChange(event, field)})}
                required={field.required}
                fullWidth={true}
                id={field.name}
                label={field.label}
                value={getValue(field)}
            />
    }

    function checkErrorInField(field : LoiFields) {
        if (!field.required) return false
    }

    function HandleChange(event: any, field : LoiFields) {
        const tmpChange : {[key : string] : any} = {}
        Object.assign(tmpChange, loiForm)
        tmpChange[field.name] = event.target.value
        setLoiForm(tmpChange)
        props.callback(tmpChange)
    }

    function getValue(field : LoiFields) : string{
        if(loiForm[field.name])
            return loiForm[field.name]
        else
            return ""
    }

    return (
        <div className="mt-2 mb-4">
            {fieldsLoi?.map(row => {
                return <div key={row.id} className="row mt-4">
                    {row.fields.map(field =>{
                        return <div key={field.name} className={"col-md-" + field.numColMd + " col-sm-12"}>
                            {renderForm(field)}
                        </div>})
                    }
                </div>})
            } 
        </div>
    )

}


export default AddLoiSection;